import React from 'react'
import About from '@/views/landing-page/About'

const AboutUs = () => {
  return (
    <About/>
  )
}

export default AboutUs